import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useUniqueId } from 'sb-hooks'
import { constants } from 'common/helpers'
import { intlMessageShape } from 'sb-react-intl'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import CircleLoader from 'components/loaders/CircleLoader/CircleLoader'
import HelpIconWithTooltip from 'components/_new/ui/HelpIconWithTooltip/HelpIconWithTooltip'

import s from './BillRow.scss'


const BillRow = ({ label, value, tooltip, isFetching, brand, id, note, onRemove }) => {
  // TODO this is ductape
  // the value must be both white-space: wrap and nowrap
  // `wrap` for long test
  // `nowrap` for price `- $30` bcs if label is too long `-` and `$30` on different lines
  // so we need to check if value is price value then replace `space` with `&nbsp;` to prevent from wrapping
  // BEST WAY: add &nbsp; to formatPrice() but then we need to render result as node, not like string...
  const _value   = /^-\s\$[\d.]+$/.test(value) ? value.replace(' ', '&nbsp;') : value
  const withNote = Boolean(note)

  const helpId = useUniqueId('help')

  const valueClassName = cx(s.value, {
    [s.brandColor]: brand,
    [s.multiline]: typeof value === 'string' && value.length > 20,
  })

  return (
    <Fragment>
      <Box mt="16" className={s.item}>
        <div className={s.label}>
          <Text message={label} dataTestId={`${id}Label`} tag="span" align="left" html />
          {
            Boolean(tooltip) && (
              <span className={s.tooltip}>
                <HelpIconWithTooltip message={tooltip} id={helpId} />
              </span>
            )
          }
          {
            typeof onRemove === 'function' && (
              <CloseIcon
                className={s.removeButton}
                onClick={onRemove}
                dataTestId={constants.testIds.payment.removeOrderItem}
              />
            )
          }
        </div>
        {
          isFetching ? (
            <CircleLoader />
          ) : (
            <div className={valueClassName}>
              {value && typeof value === 'object' ? (
                <Text message={value} dataTestId={`${id}Value`} />
              ) : (
                <span dangerouslySetInnerHTML={{ __html: _value }} data-testid={`${id}Value`} />
              )}
              {
                withNote && (
                  <sup className={s.asterix}>*</sup>
                )
              }
            </div>
          )
        }
      </Box>
      {
        !isFetching && withNote && (
          <div className={s.noteWrapper}>
            <sup className={s.asterix}>*</sup>
            <Box ml="4">
              <Text
                className={s.note}
                message={note}
                dataTestId={`${id}Note`}
                size="14-24"
                color="gray"
              />
            </Box>
          </div>
        )
      }
    </Fragment>
  )
}

BillRow.propTypes = {
  label: PropTypes.shape(intlMessageShape),
  tooltip: PropTypes.shape(intlMessageShape),
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isFetching: PropTypes.bool,
  brand: PropTypes.bool,
  id: PropTypes.string,
}


export default BillRow
